/*
 * @Description:
 * @Date: 2020-11-14 17:08:35
 */
import { index } from '@/api/ajax';
import { querySaasAndYsh } from '@/api/home';

import { storageUserInfo } from '@/utils/storage';
import store from '@/store';

export const userGuide = async (to, from, next) => {
  const channelNo = to.params.channelNo;
  const storageName = 'channel' + channelNo;
  if (!channelNo) {
    return;
  }
  // 处理切换专区不会登陆问题
  querySaasAndYsh({
    enterpriseNo: channelNo,
    channelNo
  }).then(({ pdata: { isVisitYsh } }) => {
    store.commit('channel/SET_YSH', isVisitYsh);
  });
  let { pdata } = await index.channelData({
    channelNo
  });
  store.commit('channel/SET_INFO', pdata);
  if (to.query.flag === 'admin') {
    // 处理切换专区不会登陆问题
    let { pdata } = await index.channelData({
      channelNo
    });
    store.commit('channel/SET_INFO', pdata);
    next({
      params: {
        channelNo
      },
      query: {
        flag: 'admin'
      }
    });
  } else {
    let userInfo = storageUserInfo(storageName);
    if (userInfo.id && ['sms', 'register'].includes(to.name)) {
      next({
        name: 'home',
        params: {
          channelNo
        }
      });
    }
    store.commit('user/SET_INFO', userInfo);
    next({
      params: {
        channelNo
      }
    });
  } // getUserInfoFunc(to, next);
};
